import 'script-loader!./libs/jquery.min';

import './index.scss';
import { importAll } from '../shared/index';

// Style
importAll(require.context('./scss/', true, /\.scss$/))

// Js
const allModules = require.context('./components/', true, /\.js$/)
window.onload = function() {
  importAll(allModules)
}
